<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("wms.menu.inventory") }} 
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="row">
                            <div class="col-md-4">
                                <base-input
                                    v-model="SearchKeyword"
                                    prepend-icon="fas fa-search"
                                    :placeholder="$t('search')"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select v-model="product_status">
                                        <el-option
                                            label="ทั้งหมด"
                                            value="1"
                                        ></el-option>
                                        <el-option
                                            label="สินค้าใกล้หมด"
                                            value="2"
                                        ></el-option>
                                    </el-select>
                                </base-input>
                            </div>

                            <base-input
                                v-if="product_status == 2"
                                v-model="threshold"
                                placeholder="จำนวนสินค้าต่ำกว่า"
                            >
                            </base-input>

                            <div class="col-md-2">
                                <base-button
                                    size="md"
                                    type="neutral"
                                    @click="InventoryExport()"
                                >
                                    Export
                                </base-button>
                            </div>
                        </div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            @sort-change="sortChange"
                            @selection-change="selectionChange"
                        >
                            <el-table-column
                                align="left"
                                :label="$t('product')"
                                min-width="80px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.ProductName }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column
                                v-for="s in Storage"
                                :key="s.ID"
                                align="left"
                                :label="s.Name"
                                min-width="80px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ GetBalance(row, s.ID) }} </span>
                                </div>
                            </el-table-column>

                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import wmsProductRefetchOnActivate from "@/mixins/wmsProductRefetchOnActivate";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { read, utils, writeFile } from "xlsx";

export default {
    mixins: [clientPaginationMixin, wmsProductRefetchOnActivate],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableDataOrg: "WmsInventory/getSummaryByStorage",
            Product: "WmsProduct/getData",
            StorageOrg: "WmsStorage/getData",
            SummaryByStorage: "WmsInventory/getSummaryByStorage"
        }),
        Storage: function() {
            return [
                { ID: 0,Type:0, Name: "รวมทุกคลัง" },
                ...this.StorageOrg.filter(v => {
                    return v.Type == 0;
                }),
                { ID: 999,Type:0, Name: "รอแพ็ค" }
            ];
        },
        tableData: function() {
            let result = [];
			if (this.Product.length == 0 || this.Storage.length == 0) {
				return result
			}

			this.Product.forEach((p,index) => {
				result[index] = { 
                    ProductID: p.ID, 
                    ProductName: p.Name,
                };
				result[index][0] = {
					Balance: 0,
					BalanceStamp:0,
					ItemIn: 0,
					ItemOut: 0,
					ItemOutByOrder: 0
				};
				this.Storage.forEach(s => {
					result[index][s.ID] = {
						Balance: 0,
						BalanceStamp:0,
						ItemIn: 0,
						ItemOut: 0,
						ItemOutByOrder: 0
					};
				});
			});

            let fillData = result;

            this.tableDataOrg.forEach(v => {
                v.product.forEach(p => {
                    let index = fillData.findIndex((e)=>{
						return e.ProductID == p.product_id
					})

					if (index != -1){
						fillData[index][0].Balance += p.balance;
						fillData[index][0].BalanceStamp += p.balance_stamp;
						fillData[index][0].ItemIn += p.amount_in;
						fillData[index][0].ItemOut += p.amount_out;
						fillData[index][0].ItemOutByOrder += p.amount_packing;

						let storageIndex = this.Storage.findIndex((e)=>{
							return e.ID == v.storage_id
						})

						if (storageIndex != -1) {
							fillData[index][v.storage_id].Balance = p.balance;
							fillData[index][v.storage_id].BalanceStamp = p.balance_stamp;
							fillData[index][v.storage_id].ItemIn = p.amount_in;
							fillData[index][v.storage_id].ItemOut = p.amount_out;
							fillData[index][ v.storage_id].ItemOutByOrder = p.amount_packing;
						} else {
							console.log("Not Found StorageID : " + v.storage_id)
						}
					}  else {
						console.log("Not Found ProductID : " + p.product_id)
					}
                });
            });

            let formattedData = fillData;

            if (this.SearchKeyword != "") {
                formattedData = fillData.filter(v => {
                    return ( v.ProductName.toLowerCase().indexOf(this.SearchKeyword.toLowerCase()) != -1);
                });
            }

            if (this.product_status == "2") {
                formattedData = formattedData.filter(v => {
                    if (this.threshold == "") {
                        return v[0].Balance < 500;
                    } else {
                        return v[0].Balance < parseInt(this.threshold);
                    }
                });
            }

            formattedData.sort((a, b) => {
                const productNameA = a.ProductName.toLowerCase();
                const productNameB = b.ProductName.toLowerCase();
                if (productNameA < productNameB) return -1;
                if (productNameA > productNameB) return 1;
                return 0;
            });

            return formattedData;
        },
        tableColumns: function() {
            return [
                {
                    prop: "ProductName",
                    label: this.$t("wms.product"),
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "Balance",
                    label: this.$t("wms.balance"),
                    minWidth: 120,
                    sortable: true
                },
                {
                    prop: "ItemIn",
                    label: "สินค้าเพิ่ม",
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "ItemOut",
                    label: "สินค้าเบิก",
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "ItemOutByOrder",
                    label: "สินค้าส่ง",
                    minWidth: 90,
                    sortable: true
                }
            ];
        }
    },
    data() {
        return {
            propsToSearch: ["Number", "Email"],
            selectedRows: [],
            SearchKeyword: "",
            product_status: "1",
            StorageID: 0,
            threshold: ""
        };
    },
    async mounted() {
        await this.listProduct();
        await this.listStorage();
        this.ListInventory();
        this.StorageID = this.Storage[0].ID;
    },
    methods: {
        ...mapActions({
            listData: "WmsInventory/listData",
            listProduct: "WmsProduct/listData",
            listStorage: "WmsStorage/listData",
            listHistoryV2: "WmsInventory/listHistoryStorageV2"
        }),

        ListInventory() {
            let params = {
                time_from: moment().format("YYYY-MM-DD HH:mm"),
                time_to: moment().format("YYYY-MM-DD HH:mm"),
                storage_id: 0,
                history_type: 0,
                order_id: 0,
                product_id: 0
            };
            this.listHistoryV2(params);
        },

        InventoryExport() {
            let dataExport = this.tableData.map(v => {
                let item = {
                    ID: v.ProductID,
                    ProductName: v.ProductName,
                };

                this.Storage.forEach(e => {
                    if (e.Type == 0) {
                        if (v[e.ID] != undefined) {
                            item[e.Name] = v[e.ID].Balance;
                        } else {
                            item[e.Name] = "-";
                        }
                    }
                });

                return item;
            });

            const dataWS = utils.json_to_sheet(dataExport);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, dataWS);
            writeFile(wb, "export_inventory_dashboard_v2.xlsx");
        },

        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        },
        GetBalance(row, storageId) {
            if (row[storageId] == undefined) {
                return "-";
            }

            return row[storageId].Balance;
        }
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>